export const ONGOING = 'ongoing'
export const ON_HOLD = 'on_hold'
export const COMPLETED = 'completed'